export default __webpack_public_path__ + "static/media/pursuitlogoloading-01.bb57cc88.svg";